<template>
  <b-field>
    <p class="control">
      <b-dropdown>
        <button type="button" class="button" slot="trigger">
          <span>{{$tc('dropdown.filters')}}</span>
          <b-icon icon="menu-down"></b-icon>
        </button>

        <div class="dropdown-item" style="width: 300px;">
    <b-field :label="$tc('publisher._name')">
            <publisher-select v-model="filters.publisher_id"></publisher-select>
          </b-field>

    <b-field :label="$tc('dropdown.category')">
            <magazine-category-select v-model="filters.category_id"></magazine-category-select>
          </b-field>

    <b-field :label="$tc('dropdown.country')">
            <country-select v-model="filters.country_id" expanded></country-select>
          </b-field>

    <b-field :label="$tc('dropdown.language')">
            <language-select v-model="filters.language_id" expanded></language-select>
          </b-field>
        </div>
      </b-dropdown>
    </p>

    <b-input
      @blur="searchChanged()"
      :placeholder="$tc('dater.range')"
      type="search"
      icon="magnify"
      icon-clickable
      v-model="filters.search"
      expanded
    ></b-input>

    <div class="control">
      <button type="reset" class="button" @click="reset">
        <b-icon icon="close"></b-icon>
        <span>{{$tc('reset')}}</span>
      </button>
    </div>
  </b-field>
</template>

<script>
export default {
  data() {
    return {
      filters: this.default()
    };
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit("input", this.filters);
      }
    }
  },

  methods: {
    reset() {
      this.filters = this.default();
      this.filters.search = '';
      localStorage.setItem('magazine-search', '')
    },

    default() {
      return {
        publisher_id: null,
        country_id: null,
        category_id: null,
        language_id: null,
        search: localStorage.getItem('magazine-search') || ''
      };
    },

    searchChanged(){
      localStorage.setItem('magazine-search', this.filters.search);
    }
  }
};
</script>
